import { Confirmation } from '@abp/ng.theme.shared';
import { computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { startWith } from 'rxjs';
import { IBulkActionResult } from '../../interfaces/IBulkActionResult';
import { ZnBulkActionResultService } from '../../services/zn-bulk-action-result.service';
import { ZnConfirmation } from '../../services/zn-confirmation';

export function createFormCanSaveSignal(form: FormGroup) {
  const formStatus = toSignal(form.statusChanges.pipe(startWith(form.status)), {
    initialValue: form.status,
  });

  return computed(() => {
    formStatus();
    return form.valid;
  });
}

export function isFieldInvalid(form: FormGroup, field: string): boolean {
  const control = form.get(field);
  return !!control && control.invalid && (control.touched || control.dirty);
}

export function prepareBulkActionIds(
  form: FormGroup,
  saving: boolean,
  selectedIds: number[],
): number[] | null {
  if (form.invalid) {
    form.markAllAsTouched();
    return null;
  }

  if (saving || !selectedIds.length) {
    return null;
  }

  return selectedIds;
}

export function handleBulkActionResultAndClose(
  result: Partial<IBulkActionResult> | Record<string, any> | null | undefined,
  selectedCount: number,
  bulkActionResultService: ZnBulkActionResultService,
  activeModal: NgbActiveModal,
): void {
  bulkActionResultService.handle(result, {
    selectedCount,
  });

  activeModal.close();
}

export function dismissDirtyFormModal(
  form: FormGroup,
  saving: boolean,
  confirmationService: ZnConfirmation,
  activeModal: NgbActiveModal,
): void {
  if (saving) {
    return;
  }

  if (!form.dirty) {
    activeModal.dismiss();
    return;
  }

  confirmationService.showCancelConfirmation().subscribe(status => {
    if (status === Confirmation.Status.confirm) {
      form.reset();
      activeModal.dismiss();
    }
  });
}
